import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ade11b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-2 text-body-2 font-weight-bold puntos" }

import { ref } from "vue";
import { useToast } from "@/composables/useToast";
import { useTorneoCerrado } from "@/composables/useTorneoCerrado";
import { updatePuntosExtraAsync } from "@/services/InscripcionesService";


export default /*#__PURE__*/_defineComponent({
  __name: 'PuntosExtra',
  props: {
    inscripcion: {}
  },
  emits: ["cambiado"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Para que la vista recalcule su clasificación sin recargar
const emit = __emit;

const { triggerToast } = useToast();
// Cerrado, cuentan en las posiciones guardadas: se ven pero no se cambian
const cerrado = useTorneoCerrado();
const guardando = ref(false);

const cambiar = async (puntos: number) => {
  const { inscripcion } = props;
  const anterior = inscripcion.puntosExtra ?? 0;
  guardando.value = true;
  // Se ve el cambio al momento y se deshace si falla
  // eslint-disable-next-line vue/no-mutating-props
  inscripcion.puntosExtra = anterior + puntos;
  try {
    await updatePuntosExtraAsync({
      idInscripcion: inscripcion.idInscripcion,
      puntosExtra: anterior + puntos,
    });
    emit("cambiado", inscripcion.idUsuario, anterior + puntos);
    triggerToast("success", "Puntos extra modificados correctamente.");
  } catch (error) {
    console.error("Error al actualizar puntos:", error);
    // eslint-disable-next-line vue/no-mutating-props
    inscripcion.puntosExtra = anterior;
    triggerToast("error", "Puntos extra no han podido ser modificados.");
  } finally {
    guardando.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex align-center flex-shrink-0",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    (!_unref(cerrado))
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          icon: "mdi-minus",
          size: "x-small",
          variant: "tonal",
          disabled: guardando.value,
          "aria-label": "Quitar un punto extra",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (cambiar(-1)), ["stop"]))
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.inscripcion.puntosExtra ?? 0), 1),
    (!_unref(cerrado))
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          icon: "mdi-plus",
          size: "x-small",
          variant: "tonal",
          disabled: guardando.value,
          "aria-label": "Sumar un punto extra",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (cambiar(1)), ["stop"]))
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})